import { createTranslationAPIClient } from '@/scopes/products/user-reviews/infrastructure/api/translations/translationAPIClient';

export const translationAPIClient = createTranslationAPIClient();
